/**
 * Stable CSS class names for E2E — Global Data admin screens.
 */
export const GD = {
    page: 'global-data-page',
    shellPaper: 'global-data-page__shell',
    loadingLinear: 'global-data-page__loading-linear',
    breadcrumbSection: 'global-data-page__breadcrumb-section',
    tabsWrap: 'global-data-page__tabs-wrap',
    tabsRoot: 'global-data-page__tabs',
    tabSupportedCountries: 'global-data-page-input--tab-supported-countries',
    tabSupportedLanguages: 'global-data-page-input--tab-supported-languages',
    tabSupportedCurrencies: 'global-data-page-input--tab-supported-currencies',
    tabPanelSupportedCountries: 'global-data-page__tab-panel-supported-countries',
    tabPanelSupportedLanguages: 'global-data-page__tab-panel-supported-languages',
    tabPanelSupportedCurrencies: 'global-data-page__tab-panel-supported-currencies',

    currenciesRoot: 'global-data-supported-currencies',
    currenciesToolbar: 'global-data-supported-currencies__toolbar',
    currenciesCountryFieldWrap: 'global-data-supported-currencies__country-field',
    inputSelectCountry: 'global-data-supported-currencies-input--select-country',
    currenciesTableWrap: 'global-data-supported-currencies__table-wrap',
    currenciesTable: 'global-data-supported-currencies__table',
    inputSwitchDefaultCurrency: 'global-data-supported-currencies-input--switch-default-currency',

    countriesRoot: 'global-data-supported-countries',
    countriesToolbar: 'global-data-supported-countries__toolbar',
    countriesInstanceRow: 'global-data-supported-countries__instance-row',
    countriesInstanceFieldWrap: 'global-data-supported-countries__instance-field',
    inputSelectInstanceCountries: 'global-data-supported-countries-input--select-instance',
    inputButtonAddCountry: 'global-data-supported-countries-input--button-add-country',
    countriesGridWrap: 'global-data-supported-countries__grid-wrap',
    countriesDrawerPaper: 'global-data-supported-countries-drawer',
    countriesDrawerContent: 'global-data-supported-countries-drawer__content',
    inputSelectCountryDrawer: 'global-data-supported-countries-drawer-input--select-country',
    inputSwitchDefaultCountryDrawer: 'global-data-supported-countries-drawer-input--switch-default-country',
    inputButtonCountryDrawerSubmit: 'global-data-supported-countries-drawer-input--button-submit',
    inputSwitchDefaultCountryCell: 'global-data-supported-countries-input--switch-default-country',
    inputButtonCountryRowMenu: 'global-data-supported-countries-input--button-row-menu',
    inputMenuItemCountryEdit: 'global-data-supported-countries-input--menu-item-edit',
    inputMenuItemCountryDelete: 'global-data-supported-countries-input--menu-item-delete',

    languagesRoot: 'global-data-supported-languages',
    languagesToolbar: 'global-data-supported-languages__toolbar',
    languagesInstanceRow: 'global-data-supported-languages__instance-row',
    languagesInstanceFieldWrap: 'global-data-supported-languages__instance-field',
    inputSelectInstanceLanguages: 'global-data-supported-languages-input--select-instance',
    inputButtonAddLanguage: 'global-data-supported-languages-input--button-add-language',
    languagesGridWrap: 'global-data-supported-languages__grid-wrap',
    languagesDrawerPaper: 'global-data-supported-languages-drawer',
    languagesDrawerContent: 'global-data-supported-languages-drawer__content',
    inputSelectLanguageDrawer: 'global-data-supported-languages-drawer-input--select-language',
    inputSwitchDefaultLanguageDrawer: 'global-data-supported-languages-drawer-input--switch-default-language',
    inputButtonLanguageDrawerSubmit: 'global-data-supported-languages-drawer-input--button-submit',
    inputSwitchDefaultLanguageCell: 'global-data-supported-languages-input--switch-default-language',
    inputButtonLanguageRowMenu: 'global-data-supported-languages-input--button-row-menu',
    inputMenuItemLanguageEdit: 'global-data-supported-languages-input--menu-item-edit',
    inputMenuItemLanguageDelete: 'global-data-supported-languages-input--menu-item-delete',
} as const;

/**
 * Redis cache management (same route folder; standalone page content).
 */
export const GDCM = {
    page: 'global-data-cache-management-page',
    mainGrid: 'global-data-cache-management-page__main-grid',
    headerSection: 'global-data-cache-management-page__header-section',
    filtersPaper: 'global-data-cache-management-page__filters-paper',
    filtersGrid: 'global-data-cache-management-page__filters-grid',
    inputTextDatabaseNumber: 'global-data-cache-management-page-input--text-database-number',
    inputTextKeySearch: 'global-data-cache-management-page-input--text-key-search',
    inputButtonFilter: 'global-data-cache-management-page-input--button-filter',
    inputButtonClear: 'global-data-cache-management-page-input--button-clear',
    loadingSection: 'global-data-cache-management-page__loading-section',
    resultsPaper: 'global-data-cache-management-page__results-paper',
    resultsToolbar: 'global-data-cache-management-page__results-toolbar',
    inputSwitchSelectAll: 'global-data-cache-management-page-input--switch-select-all',
    inputButtonBulkDelete: 'global-data-cache-management-page-input--button-bulk-delete',
    gridWrap: 'global-data-cache-management-page__grid-wrap',
    inputCheckboxRowSelect: 'global-data-cache-management-page-input--checkbox-row-select',
    inputButtonDeleteKey: 'global-data-cache-management-page-input--button-delete-key',
    emptyStateWrap: 'global-data-cache-management-page__empty-state',
} as const;

export const gdCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
